

import { CardMedia, Stack, useMediaQuery, useTheme } from "@mui/material";
import React, { useRef, useState } from "react";
import img1 from "./CWTA.webp";
import img2 from "./Flow.png";
import img3 from "./Payment.webp";
import img4 from "./Template.webp";

const Section11 = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const cardData = [
    {
      card_title: "Event Registration 1",
      card_description:
        "Automatically register participants via WhatsApp for your events based on chatbot-initiated interactions. Track messages, sends, opensand clicks so that no opportunity falls through the cracks.",
      card_img: img1,
    },
    {
      card_title: "Event Registration 2",
      card_description:
        "Track real-time analytics and registrations using WhatsApp-based campaign systems tailored to your needs.",
      card_img: img2,
    },
    {
      card_title: "Event Registration 3",
      card_description:
        "Gather payments for your event registrations directly via WhatsApp integrated payment gateways.",
      card_img: img3,
    },
    {
      card_title: "Event Registration 4",
      card_description:
        "Send smart reminders and follow-ups to incomplete registrations to boost participation.",
      card_img: img4,
    },
  ];

  const [selectedIndex, setSelectedIndex] = useState(0); // default 0

  const touchStartX = useRef(null);
  const touchEndX = useRef(null);

  const handleSwipe = () => {
    if (touchStartX.current - touchEndX.current > 50 && selectedIndex < 3) {
      setSelectedIndex((prev) => prev + 1);
    } else if (
      touchEndX.current - touchStartX.current > 50 &&
      selectedIndex > 0
    ) {
      setSelectedIndex((prev) => prev - 1);
    }
  };

  const handleTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
  };

  const handleTouchMove = (e) => {
    touchEndX.current = e.touches[0].clientX;
  };

  const selectedCard = cardData[selectedIndex];

  return (
    <Stack
      sx={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        height: "70vh",
        marginTop: "80px",
      }}
    >
      <Stack
        sx={{
          width: { xl: "72%", lg: "89%", md: "89%", sm: "100%", xs: "92%" },
          height: "100%",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {/* Navigation Buttons */}
        <Stack
          sx={{
            display: "flex",
            flexDirection: "row",
            gap: { xs: 2, sm: 5 },
            height: "6%",
            justifyContent: "center",
          }}
        >
          {[0, 1, 2, 3].map((index) => (
            <Stack
              key={index}
              sx={{
                width: "20%",
                border: "1px solid #ddd",
                borderTopLeftRadius: "8px",
                borderTopRightRadius: "8px",
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
                cursor: "pointer",
                backgroundColor:
                  selectedIndex === index
                    ? "rgb(5, 78, 146)"
                    : "rgb(31, 133, 192)",
                fontWeight: selectedIndex === index ? 600 : 400,
              }}
              onClick={() => setSelectedIndex(index)}
            >
              {index + 1}
            </Stack>
          ))}
        </Stack>

        {/* Content Section */}

        <Stack
          onTouchStart={isMobile ? handleTouchStart : null}
          onTouchMove={isMobile ? handleTouchMove : null}
          onTouchEnd={isMobile ? handleSwipe : null}
          sx={{
            height: "94%",
            width: "100%",
            border: "1px solid #f0fcfc",
            backgroundColor: "#f0fcfc",
          }}
        >
          <Stack
            sx={{
              height: "94%",
              width: "100%",
              border: "1px solid #f0fcfc",
              backgroundColor: "#f0fcfc",
            }}
          >
            <Stack
              sx={{
                display: "flex",
                flexDirection: {
                  xl: "row",
                  lg: "row",
                  md: "row",
                  sm: "row",
                  xs: "column",
                },
                height: "100%",
                width: "100%",
                padding: { xl: 4, lg: 4, md: 3, sm: 3, xs: 0 },
              }}
            >
              <Stack
                sx={{
                  height: {
                    xl: "100%",
                    lg: "100%",
                    md: "100%",
                    sm: "100%",
                    xs: "50%",
                  },
                  width: {
                    xl: "45%",
                    lg: "45%",
                    md: "45%",
                    sm: "45%",
                    xs: "100%",
                  },
                  border: "1px solid green",
                  marginTop: "16px",
                  display: { xs: "flex", sm: "none" },
                }}
              >
                <CardMedia
                  component="img"
                  image={selectedCard.card_img}
                  alt={selectedCard.card_title}
                  sx={{
                    height: "100%",
                    width: "100%",
                    padding: 2,
                    objectFit: "contain",
                  }}
                />
              </Stack>
              <Stack
                sx={{
                  height: {
                    xl: "100%",
                    lg: "100%",
                    md: "100%",
                    sm: "100%",
                    xs: "50%",
                  },
                  width: {
                    xl: "55%",
                    lg: "55%",
                    md: "55%",
                    sm: "55%",
                    xs: "100%",
                  },
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: {
                    xl: "center",
                    lg: "center",
                    md: "center",
                    sm: "center",
                    xs: "flex-start",
                  },
                  // border: "2px solid red",
                  // alignItems: "center",
                  alignItems: {
                    xl: "center",
                    lg: "center",
                    md: "center",
                    sm: "center",
                    xs: "flex-start", // 👈 Add this line
                  },
                  gap: 2,
                }}
              >
                <Stack
                  sx={{
                    fontSize: {
                      xl: "40px",
                      lg: "40px",
                      md: "32px",
                      sm: "32px",
                      xs: "20px",
                    },
                    fontWeight: 600,
                    lineHeight: {
                      xl: "44px",
                      lg: "44px",
                      md: "36px",
                      sm: "36px",
                      xs: "32px",
                    },
                    fontFamily: "'Roboto', sans-serif",
                    textAlign: "left",
                    display: { xs: "none", sm: "flex" },
                  }}
                >
                  {selectedCard.card_title}
                </Stack>

                <Stack
                  sx={{
                    fontFamily: "'Roboto', sans-serif",
                    fontSize: {
                      xs: "24px",
                      sm: "30px",
                      md: "28px",
                      lg: "48px",
                      xl: "48px",
                    },
                    lineHeight: {
                      xs: "28px",
                      sm: "36px",
                      md: "32px",
                      lg: "52px",
                      xl: "52px",
                    },
                    fontWeight: 600,
                    color: "rgb(5 78 146)",
                    textAlign: "center",
                    marginBottom: {
                      xs: "20px",
                      sm: "20px",
                      md: "20px",
                      lg: "20px",
                      xl: "20px",
                    },
                    marginTop: {
                      xs: "20px",
                      sm: "20px",
                      md: "40px",
                      lg: "64px",
                      xl: "64px",
                    },
                    // border: "1px solid red",
                    display: { xs: "flex", sm: "none" },
                    flexDirection: "row",
                    marginLeft: { xs: "8px", sm: "0px" },
                  }}
                >
                  <Stack
                    sx={{
                      // border: "1px solid red",
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Stack
                      sx={{
                        width: { xl: "6px", lg: "6px", xs: "4px" },
                        // height: { xl: "100%", lg: "100%", xs: "100%" },
                        height: {
                          xs: "20px",
                          sm: "44px",
                          md: "28px",
                          lg: "40px",
                          xl: "40px",
                        },
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        border: "1px solid rgb(5 78 146)",
                        // backgroundColor: "rgb(5 78 146)",
                        backgroundColor: "rgb(5 78 146)",
                        marginRight: {
                          xs: "8px",
                          sm: "8px",
                          md: "12px",
                          lg: "12px",
                          xl: "12px",
                        },
                        borderTopRightRadius: "8px", // Adjust the value as needed
                        borderBottomRightRadius: "8px", // Adjust the value as needed
                      }}
                    >
                      <h4 style={{ color: "rgb(5 78 146)" }}>{""}</h4>
                    </Stack>
                  </Stack>
                  <span
                    style={{ display: "inline-flex", alignItems: "center" }}
                  >
                    {selectedCard.card_title}
                  </span>
                </Stack>
                <Stack
                  sx={{
                    fontSize: {
                      xl: "28px",
                      lg: "28px",
                      md: "20px",
                      sm: "20px",
                      xs: "16px",
                    },
                    fontWeight: 400,
                    lineHeight: {
                      xl: "32px",
                      lg: "32px",
                      md: "24px",
                      sm: "24px",
                      xs: "20px",
                    },
                    fontFamily: "'Roboto', sans-serif",
                    textAlign: "left",
                    marginLeft: { xs: "8px", sm: "0px" },
                    color: "#333",
                    width: "96%",
                  }}
                >
                  {selectedCard.card_description}
                </Stack>
              </Stack>
              <Stack
                sx={{
                  height: {
                    xl: "100%",
                    lg: "100%",
                    md: "100%",
                    sm: "100%",
                    xs: "50%",
                  },
                  width: {
                    xl: "45%",
                    lg: "45%",
                    md: "45%",
                    sm: "45%",
                    xs: "100%",
                  },
                  border: "1px solid green",
                  display: { xs: "none", sm: "flex" },
                }}
              >
                <CardMedia
                  component="img"
                  image={selectedCard.card_img}
                  alt={selectedCard.card_title}
                  sx={{
                    height: "100%",
                    width: "100%",
                    padding: 2,
                    objectFit: "contain",
                  }}
                />
              </Stack>
            </Stack>
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default Section11;

